/**
 * 새 배포 감지 시 새로고침 유도 배너.
 * 레거시 `pages/_app.js` 우측 하단 고정 배너 UI 포팅.
 */
import { useAppVersionCheck } from '@/shared/hooks/useAppVersionCheck';
import { Button } from '@/shared/components/ui/button';
import React from 'react';

export const VersionUpdateBanner: React.FC = () => {
  const { hasUpdate } = useAppVersionCheck();

  if (!hasUpdate) return null;

  return (
    <div
      role="status"
      className="fixed bottom-4 right-4 z-[9999] flex items-center gap-3 rounded-lg bg-foreground px-4 py-3 text-sm text-background shadow-lg"
    >
      <span>새 버전이 배포되었습니다.</span>
      <Button
        type="button"
        size="sm"
        variant="secondary"
        className="bg-background text-foreground hover:bg-background/90"
        onClick={() => window.location.reload()}
      >
        새로고침
      </Button>
    </div>
  );
};
